import { render, staticRenderFns } from "./WashcloudFactory.vue?vue&type=template&id=66dbbcc1&scoped=true&"
import script from "./WashcloudFactory.vue?vue&type=script&lang=js&"
export * from "./WashcloudFactory.vue?vue&type=script&lang=js&"
import style0 from "./WashcloudFactory.vue?vue&type=style&index=0&id=66dbbcc1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66dbbcc1",
  null
  
)

export default component.exports